import css from './index.module.scss';
import MapBox from './Map';
import ControlBox from './ControlBox';
import StoreList from './StoreList';
import BrandLists from './BrandLists';
import PRHIVK from './PRHIVK';
import { useGlobal } from '@/utils/useGlobal';

export default function WhereToBuyPC() {
    const { useLang, useRouter, useState, gtm } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const [active, setActive] = useState(locale === 'ca' ? 'offcial' : 'retail');
    const [zoom, setZoom] = useState(12);
    const [showLogoCard, setShowLogoCard] = useState({ show: false, data: {} });
    const [storeLists, setStoreLists] = useState([]);
    const [center, setCenter] = useState();
    const onRecordClick = (store: any) => {
        setShowLogoCard({ show: true, data: store });
        setCenter({ lat: Number(store.latitude), lng: Number(store.longitude) });
        setZoom(14);
    };

    const onClickTab = (tab: string, tabText: string) => {
        active !== tab && setActive(tab);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: tabText,
        });
    };

    return (
        <div className={`whereToBuy_pc ${css.whereToBuy_pc}`}>
            <h1 className="title">{t('title')}</h1>
            <div className="subTitle">{t('subTitle')}</div>
            <div className="tabsContainer">
                {['us', 'cn', 'ca'].includes(locale) && (
                    <div className="tabs">
                        {['us', 'cn'].includes(locale) && (
                            <li className={`${active === 'retail' ? 'active' : ''} tab_item`} onClick={() => onClickTab('retail', t('tab_retailStore'))}>
                                <span className="text">{t('tab_retailStore')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'offcial' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('offcial', t('tab_offcialOnlineStores'))}
                            >
                                <span className="text">{t('tab_offcialOnlineStores')}</span>
                            </li>
                        )}
                        {['us', 'ca'].includes(locale) && (
                            <li className={`${active === 'PR_HI_VK' ? 'active' : ''} tab_item`} onClick={() => onClickTab('PR_HI_VK', t('tab_PR_HI_VK'))}>
                                <span className="text">{t('tab_PR_HI_VK')}</span>
                            </li>
                        )}
                    </div>
                )}
                <div className={`retailStoreBox ${active === 'retail' ? 'active' : ''}`}>
                    <ControlBox
                        onBackStore={(value: any) => setStoreLists(value)}
                        onBackCenter={(value: any) => setCenter(value)}
                        onBackLogoCard={(obj: any) => setShowLogoCard(obj)}
                    />
                    <div className="resultBox">
                        <StoreList storeLists={storeLists} onRecordClick={onRecordClick} />
                        <MapBox storeLists={storeLists} center={center} zoom={zoom} showLogoCard={showLogoCard} />
                    </div>
                </div>
                <div className={`offcailOnlineStores ${active === 'offcial' ? 'active' : ''}`}>
                    <BrandLists />
                </div>
                <div className={`PRHIVK ${active === 'PR_HI_VK' ? 'active' : ''}`}>
                    <PRHIVK />
                </div>
            </div>
            <style jsx global>
                {`
                    #allContentContainer {
                        overflow: auto;
                    }
                `}
            </style>
        </div>
    );
}
